var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEject = function SvgIconEject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.352a1.74 1.74 0 0 0-1.284.565L3.5 10.416l-.006.006a1.75 1.75 0 0 0 1.269 2.953h14.477a1.75 1.75 0 0 0 1.269-2.953l-.006-.006-7.217-7.499A1.74 1.74 0 0 0 12 2.352M11.447 3.6l.747.665-.028.027zm-6.096 7.775 6.65-6.908 6.648 6.908zM2.75 18.75c0 .966.784 1.75 1.75 1.75h15a1.75 1.75 0 0 0 1.75-1.75V16.5a1.75 1.75 0 0 0-1.75-1.75h-15a1.75 1.75 0 0 0-1.75 1.75zm16.5-.25H4.75v-1.75h14.5z"
  }))));
};
export default SvgIconEject;